import { gql } from '@apollo/client'

export const GET_STORE_AUDITS_FOR_PICOS = gql`
  query GetStoreAuditsForPicos($input: AuditsInput!) {
    audits(input: $input) {
      results {
        id
        created
        saved
        dateCompleted
        displaysCompletedAt
        pricingCompletedAt
        surveyCompletedAt
        employee {
          firstName
          lastName
          id
          email
        }
        displayAudits {
          id
        }
      }
      hasMore
      count
    }
  }
`
